import {getArea} from '@apps-common/geocorn-sdk/geom/cea';
import {object} from 'prop-types';
import React from 'react';

import {useSelector} from 'react-redux';
import AreaIndicator from './AreaIndicator.jsx';
import {getSearchGeometryGeoJson} from '@app/selectors/search';

const GeometryAreaIndicator = ({geometry: propsGeometry}) => {
  const searchGeometry = useSelector(getSearchGeometryGeoJson);
  const geometry = propsGeometry || searchGeometry;

  if (!geometry) {
    return '';
  } else {
    const squareMeters = getArea(geometry);
    return <AreaIndicator squareMeters={squareMeters} />;
  }
};

GeometryAreaIndicator.propTypes = {
  geometry: object,
};

export default GeometryAreaIndicator;
